/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportConnectRudoApiKeyMutationRequest, SocialExportConnectRudoApiKeyMutationResponse, SocialExportConnectRudoApiKey400, SocialExportConnectRudoApiKey401, SocialExportConnectRudoApiKey403 } from "../models/SocialExportConnectRudoApiKey";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { socialExportConnectRudoApiKey } from "../axios/socialExportConnectRudoApiKey";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const socialExportConnectRudoApiKeyMutationKey = () => [{ url: '/social-export/v1/auth/rudo/api-key' }] as const

export type SocialExportConnectRudoApiKeyMutationKey = ReturnType<typeof socialExportConnectRudoApiKeyMutationKey>

export function socialExportConnectRudoApiKeyMutationOptions<TContext = unknown>(config: Partial<RequestConfig<SocialExportConnectRudoApiKeyMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = socialExportConnectRudoApiKeyMutationKey()
        return mutationOptions<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, {data: SocialExportConnectRudoApiKeyMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return socialExportConnectRudoApiKey(data, config)
          },
        })

}

/**
 * @description Creates a client-owned Rudo connection using a static access token. Assign the connection to stations separately.
 * @summary Connect Rudo with an access token
 * {@link /social-export/v1/auth/rudo/api-key}
 */
export function useSocialExportConnectRudoApiKey<TContext>(options: 
{
  mutation?: UseMutationOptions<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, {data: SocialExportConnectRudoApiKeyMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<SocialExportConnectRudoApiKeyMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? socialExportConnectRudoApiKeyMutationKey()

          const baseOptions = socialExportConnectRudoApiKeyMutationOptions(config) as UseMutationOptions<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, {data: SocialExportConnectRudoApiKeyMutationRequest}, TContext>
          

          return useMutation<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, {data: SocialExportConnectRudoApiKeyMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<SocialExportConnectRudoApiKeyMutationResponse, ResponseErrorConfig<SocialExportConnectRudoApiKey400 | SocialExportConnectRudoApiKey401 | SocialExportConnectRudoApiKey403>, {data: SocialExportConnectRudoApiKeyMutationRequest}, TContext>
      
}